import LoginPage from 'views/loginPage';
import AlreadyLoggedPage from 'views/alreadyLoggedPage';
import ForgotPasswordPage from 'views/forgotPasswordPage';
import NewPasswordPage from 'views/newPasswordPage';
import AuthErrorPage from 'views/authErrorPage';
import EnterPage from 'views/enterPage';

export const routes = [
  {
    name: 'login-page',
    path: '/login',
    Element: LoginPage,
  },
  {
    name: 'enter-page',
    path: '/enter',
    Element: EnterPage,
  },
  {
    name: 'already-logged-page',
    path: '/already-logged',
    Element: AlreadyLoggedPage,
  },
  {
    name: 'forgot-password-page',
    path: '/forgot-password',
    Element: ForgotPasswordPage,
  },
  {
    name: 'new-password-page',
    path: '/new-password',
    Element: NewPasswordPage,
  },
  {
    name: 'auth-error-page',
    path: '/auth-error',
    Element: AuthErrorPage,
  },
];